import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { DIRECT_QUESTION_TYPE } from 'constants/survey';
import i18n from 'i18next';
import './styles.scss';

const CommentArea = ({
    handleFocus,
    handleBlur,
    handleCommentInput,
    questionComment,
    questionIdx,
    clearComment,
    questionType,
    shouldFocusCommentInput
}) => {
    const textFieldRef = useRef(null);

    const shouldShowClear = !!questionComment;

    if (questionType === DIRECT_QUESTION_TYPE) return null;

    if (shouldFocusCommentInput) {
        textFieldRef.current.focus();
    }

    return (
        <div className='comment-area-container'>
            <textarea
                ref={ textFieldRef }
                id={ `comment-${ questionIdx }` }
                className='comment'
                placeholder={ i18n.t('engagement.type_your_comment_here') }
                value={ questionComment || '' }
                onChange={ handleCommentInput }
                onBlur={ handleBlur }
                onFocus={ handleFocus } />
            {
                shouldShowClear && (
                    <button
                        id='comment-area-cancel-button'
                        className='cancel-button'
                        onClick={ clearComment }>
                        { i18n.t('engagement.clear') }
                    </button>
                )
            }
        </div>
    );
};


CommentArea.propTypes = {
    handleFocus: PropTypes.func,
    handleBlur: PropTypes.func,
    handleCommentInput: PropTypes.func,
    questionComment: PropTypes.string,
    questionIdx: PropTypes.number,
    clearComment: PropTypes.func,
    questionType: PropTypes.string,
    shouldFocusCommentInput: PropTypes.bool
};

CommentArea.defaultProps = {
    handleFocus: null,
    handleBlur: null,
    handleCommentInput: null,
    questionComment: null,
    questionIdx: null,
    clearComment: null,
    questionType: null,
    shouldFocusCommentInput: false
};


export default CommentArea;
